import { render, staticRenderFns } from "./admins.vue?vue&type=template&id=60df4324&scoped=true"
import script from "./admins.vue?vue&type=script&lang=js"
export * from "./admins.vue?vue&type=script&lang=js"
import style0 from "./admins.vue?vue&type=style&index=0&id=60df4324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df4324",
  null
  
)

export default component.exports